/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import DateInput from './DateInput';
import TextInput from './TextInput';
import ValueList from './ValueList';
import NumericValueList from './NumericValueList';
import TextValueList from './TextValueList';
import NumberInput from './NumberInput';
import TableInput from './TableInput';
import { BaseInputProps } from './InputProps';
import { UtrValueType } from '../../../../types/universalTracker';
import { shouldEnforceWeightedAggregationTableUI } from '../../../../utils/universalTracker';

const isTableInput = (p: BaseInputProps): p is BaseInputProps & { universalTracker: { getValueType(): UtrValueType.Table } } => {
  return p.universalTracker.getValueType() === UtrValueType.Table;
}

export const InputFactory = (props: BaseInputProps) => {

  const { universalTracker, initiativeUtr, shouldAutoOptInToWeightedAggregation } = props;

  const shouldEnforceTable = shouldEnforceWeightedAggregationTableUI({
    valueType: universalTracker.getValueType(),
    aggregationValueType: universalTracker.getAggregationValueType(),
    initiativeAggregationValueType: initiativeUtr?.aggregationValueType,
    isAutoOptIn: !!shouldAutoOptInToWeightedAggregation,
  });

  if (isTableInput(props) || shouldEnforceTable) {
    return <TableInput {...props} />;
  }

  switch (props.universalTracker.getValueType()) {
    case 'date':
      return <DateInput {...props} />;
    case 'text':
      return <TextInput {...props} />;
    case 'valueList':
      return <ValueList {...props}/>;
    case 'valueListMulti':
      return <ValueList multi={true} {...props}/>;
    case 'numericValueList':
      return <NumericValueList {...props}/>;
    case 'textValueList':
      return <TextValueList {...props}/>;
    case 'number':
    case 'percentage':
      return <NumberInput {...props}/>;
    case 'table':
      return <TableInput {...props}/>;
    default:
      return <>Unsupported value type ${props.universalTracker.getValueType()}</>;
  }
};
